"use client";
import { db } from "@/app/firebase_config/firebase_config";
import { collection, getDocs } from "firebase/firestore";
import { ProductPrice } from "../data/passticket_type";

export const numberFormatter = new Intl.NumberFormat('ko-KR', {
  style: 'currency',
  currency: 'KRW',
  // minimumFractionDigits: 2,
  // maximumFractionDigits: 2
});

export const usdFormatter = new Intl.NumberFormat('us-EN', {
  style: 'currency',
  currency: 'USD',
  // minimumFractionDigits: 2,
  // maximumFractionDigits: 2
});

export const chnageKey = (type: number) => {
  var result = '';
  switch (type) {
    case 1:
      result = "klook"
      break;
    case 2:
      result = "Myrealtrip"
      break;
    case 3:
      result = "kkday"
      break;
    case 4:
      result = "Trip.com"
      break;
    case 5:
      result = "Ndaytrip"
      break;
    default:
      break;
  }
  return result;
}

export async function fetchDataPassTickets(area: string, target: string) {
  try {
    const querySnapshot = await getDocs(collection(db, "Rates", area, target));
    const results = querySnapshot.docs.map((doc: any) => ({
      ...doc.data(),
      id: doc.id,
    }));

    results.forEach(element => {
      const sorted = sortPrice(element.prices);
      element.prices = [...sorted];
    });

    results.sort((a, b) => {
      return a.order - b.order;
    });

    return results;
  } catch (e) {
    console.error("fetchDataPassTickets error", e);
    return [];
  }
}

const sortPrice = (prices: Array<ProductPrice>) => {
  const byData = prices.slice(0)
  byData.sort((a, b) => {
    return a.price - b.price;
  })
  return byData;
}



export async function fetchDataBustour(area: string, target: string) {
  const querySnapshot = await getDocs(collection(db, "Rates", area, target));
  const results = querySnapshot.docs.map((doc: any) => (
    {
      ...doc.data(),
      id: doc.id,
    }));

  results.sort((a, b) => {
    return a.order - b.order;
  });

  results.forEach(element => {
    element.products.sort((a: any, b: any) => {
      return a.price - b.price;
    });
  });
  return results;
}